export var OutputControlType;
(function (OutputControlType) {
    OutputControlType[OutputControlType["Newsletter"] = 0] = "Newsletter";
    OutputControlType[OutputControlType["BidNotice"] = 1] = "BidNotice";
    OutputControlType[OutputControlType["OutbidNotice"] = 2] = "OutbidNotice";
})(OutputControlType || (OutputControlType = {}));
